module.exports = __webpack_public_path__ + "img/advanced4.37e5efd1.png";